<template>
  <list-view-cell
    class="scope-of-work-cell"
    :context-menu-items="contextMenuItems"
  >
    <div class="category pt-1">
      <h3 class="uppercase font-light text-sm">
        <i class="fal fa-pencil fa-fw pr-2 text-blue" /> {{ scope.category }}
      </h3>
    </div>

    <div class="details w-full mt-2">
      <p>Location of Project: {{ scope.location }}</p>
      <p>Type of Project: {{ scope.type }}</p>
    </div>

    <template #bottom>
      <div class="w-full mt-2 px-4 pb-4">
        <div
          class="scope-items"
          v-if="scope.scope_items && scope.scope_items.length"
        >
          <p class="mb-1">Required scope items:</p>
          <bdg-simple-list :items="scope.scope_items.map(i => i.name)" />
        </div>

        <div
          class="change-orders"
          v-if="scope.change_orders && scope.change_orders.length"
        >
          <p class="mb-1">Required change orders:</p>
          <bdg-simple-list :items="scope.change_orders.map(i => i.name)" />
        </div>

        <div
          class="design-sheets"
          v-if="scope.design_sheets && scope.design_sheets.length"
        >
          <p class="mb-1">Required design sheets:</p>
          <bdg-simple-list :items="scope.design_sheets.map(i => i.name)" />
        </div>

        <div
          class="additional-services mt-6"
          v-if="scope.additional_services && scope.additional_services.length"
        >
          <p class="mb-1">Additional services:</p>
          <bdg-simple-list
            :items="scope.additional_services.map(i => i.name)"
          />
        </div>
      </div>
    </template>
  </list-view-cell>
</template>

<script>
import ListViewCell from "../ListViewCell";
import { ContextMenuItem } from "../../../../helper-classes/ContextMenuItem";
import ScopeOfWorkForm from "../../../../views/contracts/forms/ScopeOfWorkForm";
import BdgSimpleList from "../../../simple-list/BdgSimpleList";

export default {
  name: "ScopeOfWorkCell",
  components: { BdgSimpleList, ListViewCell },
  props: {
    scope: Object
  },
  data() {
    return {
      contextMenuItems: [
        new ContextMenuItem("edit", () => {
          this.$store.commit("setCreateEditComponentParams", {
            createEditComponent: ScopeOfWorkForm,
            createEditComponentData: this.scope,
            createEditComponentIsShown: true
          });
        }),
        new ContextMenuItem("delete", () => {
          this.$store.commit("setConfirmationModalParams", {
            type: "delete",
            headerText: "Delete Confirmation",
            bodyComponent: undefined,
            bodyComponentData: this.scope,
            isShown: true
          });
        })
      ]
    };
  }
};
</script>

<style scoped></style>
